import { useI18n } from "#imports";

export const useSiteNavigationLd = () => {
  const { t } = useI18n();

  const siteLink = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "itemListElement": [
      { "@type": "SiteNavigationElement", "name": t("seo.home.skillCertify.title"), "url": "https://codepresso.io/home/skillCertify" },
      { "@type": "SiteNavigationElement", "name": t("seo.home.skillMonitor.title"), "url": "https://codepresso.io/home/skillMonitor" },
      { "@type": "SiteNavigationElement", "name": t("seo.home.skillAdvance.title"), "url": "https://codepresso.io/home/skillAdvance" },
      { "@type": "SiteNavigationElement", "name": t("seo.home.hiring.title"), "url": "https://codepresso.io/home/hiring" }
    ]
  };

  return { type: 'application/ld+json', innerHTML: JSON.stringify(siteLink)}
};
